module.exports = __webpack_public_path__ + "static/scale-model-of-celebration-park-in-allen-texas-93e456adfd2bc64d6c23c99bf733e94d.png";